var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkGuidance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Arrow-Roadmap--Streamline-Flex",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Arrow Roadmap Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-roadmap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1226",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.5 2.5h3.75c1.2426 0 2.25 1.00736 2.25 2.25 0 1.15816 -0.875 2.11194 -2.0001 2.23627",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1229",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 7H3.75C2.50736 7 1.5 8.00736 1.5 9.25c0 1.1582 0.87504 2.1119 2.00006 2.2363",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1227",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13 11.5H6.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1228",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.5 2.5h-2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 446",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.5 2.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 448",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.5 11.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 447",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 7a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.5 12.9863c0.5625 0 1.3125 -0.75 1.5 -1.5 -0.1875 -0.75 -0.9375 -1.50003 -1.5 -1.50003",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGuidance);
export default __webpack_public_path__ + "static/media/dark-guidance.90daa436f5d4726f6b28bb5744b6150c.svg";
export { ForwardRef as ReactComponent };